var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-overlay",
    { attrs: { id: "wholesale-products", show: _vm.loading } },
    _vm._l(_vm.types, function (type) {
      return _c(
        "div",
        { key: `type-${type.id}`, staticClass: "wholesale-type" },
        [
          _c("h2", [_vm._v(_vm._s(type.wholesale_meta.page_title))]),
          _c("p", { staticClass: "lead" }, [
            _vm._v(_vm._s(type.wholesale_meta.page_description)),
          ]),
          _c(
            "b-row",
            { staticClass: "grid" },
            [
              _vm._l(type.categories, function (cat) {
                return _vm._l(cat.products, function (product) {
                  return _c("wholesale-product", {
                    key: `prod-${product.id}`,
                    attrs: {
                      product: product,
                      type: type,
                      "is-selected": _vm.selected == product.meta.slug,
                    },
                  })
                })
              }),
            ],
            2
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }